<template>
  <div>
    <div class="flex flexContainer">
      <div class="item-left">
        <div class='license' v-text='driverData.plateNumber'></div>
        <div class="car-Text" title='++6526565416565'>
          <span v-text='driverData.vehicleColor'></span>
          <span class='yuan'></span>
          <span v-text='driverData.brandModel'></span>
          </div>
        <div>
          <van-image width="117" height="46" :src="carUrl" />
        </div>
      </div>
      <div class="item-center">
        <span class="wire"></span>
      </div>
      <div class="flex item-right">
        <div> 
          <van-image round scale-down width="45" height="45" :src="driverData.headPortrait" />
        </div>
        <div class="driver-msg">
          <div class='driver-text' v-text='driverData.driverName'></div>
          <div class="driver-msg-item">
            <van-image width="9" height="9" :src="xinUrl" />
            <span class='grade' v-text='driverData.averageScore'></span>
            <span>{{driverData.orderCount}}单</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    driverData:{
      type:Object
    }
  },
  data(){
    return{
      xinUrl:require('../../assets/icon/icon-xin.png'),
      carUrl:require('../../assets/home/car1.png')
    }
  }
};
</script>
<style lang="scss" scoped>
$gray3:#333;
$gray6:#666666;
$grayDf:#eFeFeF;
.flexContainer {
  box-sizing: border-box;
  text-align: center;
  font-size:32px;
  justify-content: space-between;
  color:$gray3;
  padding-top:20px;
  padding-bottom:20px;
 
  .item-left,.item-right{
    width:47%
  }
  .item-left{
    .license{font-weight: 500;font-size: 42px;}
    .car-Text{
      color:$gray6;
      font-size: 24px;
      display: flex;
      justify-content:center;
      align-items: center;
      padding-bottom:15px;
      .yuan{
        display: inline-block;
        width:10px;height:10px;
        background:$gray6;
        border-radius: 16px;
        margin-left:10px;margin-right:10px;
      }
    }
  } 
  .item-center{
     .wire{
       display:inline-block;
       border-right:1px solid $grayDf;height:50px;
       }
  }
  .item-right{
    .driver-msg{
      margin-left:25px;
      text-align: left;
      .driver-text{
        font-size:34px;
        color:$gray3;
        line-height: 50px;
      }
      .driver-msg-item{
        font-size: 26px;
        color:$gray6;
      .grade{
         
        padding:0 12px;
      }
      }
    }
  }
  
}
</style>